var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"btn",attrs:{"to":"/download/app"}},[_vm._v(_vm._s(_setup.props.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }